import { cn } from "@/lib/utils";
import React from "react";

export const MappingSearchResultList = ({
  label,
  children,
  className,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col items-start self-stretch", className)}>
      <div className="flex py-[12px] px-[16px] h-11 items-center gap-[10px] self-stretch border-t-[1px] border-neutral-200">
        <span className="text-[#0A0A0A] caption-1-semibold">{label}</span>
      </div>
      {children}
    </div>
  );
};
